<div v-vl-highlight-content>
    <form @submit="onSubmit">
        <vl-form-grid>
            <vl-column>
                <fieldset>
                    <vl-title tag-name="h3">Activering geometrie</vl-title>
                    <vl-form-grid mod-stacked>
                        <vl-column>
                            <slot name="content"></slot>
                        </vl-column>
                        <vl-column width="3">
                            <kl-field-validation-wrapper-yup for="date-activate" :field="fields.activationDate" #default="{hasErrors}" mod-required>
                                <kl-datepicker name="activeringsdatum" id="date-activate"
                                    :min-date="geometryActivationMinDate" v-model="activationDate"
                                    :mod-error="hasErrors" />
                            </kl-field-validation-wrapper-yup>
                        </vl-column>
                    </vl-form-grid>
                </fieldset>
            </vl-column>
            <vl-u-spacer />
            <vl-column>
                <fieldset>
                    <vl-title tag-name="h3">Uw referenties</vl-title>
                    <vl-form-grid mod-stacked>
                        <vl-column>
                            <p>KLIP doet niets met deze optionele gegevens. U kan deze gebruiken om de opgeladen geometrie
                                achteraf
                                te identificeren.</p>
                        </vl-column>
                        <vl-column width="6" width-m="9" width-s="12">
                            <kl-field-validation-wrapper-yup for="reference" :field="fields.reference" #default="{hasErrors}">
                                <vl-input-field name="referentie" id="reference"
                                    v-model="reference" :mod-error="hasErrors" mod-block/>
                            </kl-field-validation-wrapper-yup>
                        </vl-column>
                        <vl-column width="6" width-m="3" width-s="12" v-vl-visibility:hide.s></vl-column>
                        <vl-column width="2" width-m="3" width-s="4" width-xs="6">
                            <kl-field-validation-wrapper-yup for="version" :field="fields.version" #default="{hasErrors}">
                                <vl-input-field name="versie" id="version" v-model="version"
                                    :mod-error="hasErrors" mod-block />
                            </kl-field-validation-wrapper-yup>
                        </vl-column>
                        <vl-column width="2" width-m="3" width-s="4" width-xs="12">
                            <kl-field-validation-wrapper-yup for="accuracy" :field="fields.precision" #default="{hasErrors}">
                                <vl-input-group>
                                    <vl-input-field type="number" name="nauwkeurigheid" id="accuracy"
                                        v-model="precision" :mod-error="hasErrors"
                                        mod-block />
                                    <vl-input-addon tooltip="In meter" text="m" />
                                </vl-input-group>
                            </kl-field-validation-wrapper-yup>
                        </vl-column>
                        <vl-column width="2" width-m="3" width-s="4" width-xs="12">
                            <kl-field-validation-wrapper-yup for="date-modified" :field="fields.lastModificationDate" #default="{hasErrors}">
                                <kl-datepicker name="laatstbewerkt" id="date-modified"
                                    :max-date="geometryLastModificationMaxDate" v-model="lastModificationDate"
                                    :mod-error="hasErrors" />
                            </kl-field-validation-wrapper-yup>
                        </vl-column>
                    </vl-form-grid>
                </fieldset>
            </vl-column>
            <vl-u-spacer />
            <vl-column>
                <fieldset>
                    <vl-title tag-name="h3">Uw geometrie *</vl-title>
                    <vl-form-grid mod-stacked>
                        <vl-column>
                            <kl-field-validation-wrapper-yup :field="fields.wkt" :manual-error-messages="geometryErrorMessages" #default="{hasErrors}" mod-hidden-label>
                                <kl-draw-zone-map
                                    :mod-maprequest-zone="false"
                                    :for-geometry="true"
                                    :mod-enable-multi-zones="false"
                                    :no-confirmation="true"
                                    :mod-show-km-hm-toggle="false"
                                    :mod-disabled="validatingGeometry"
                                    :mod-error="hasErrors"
                                    @input="onNewGeometryChanged"
                                />
                            </kl-field-validation-wrapper-yup>
                        </vl-column>
                    </vl-form-grid>
                </fieldset>
            </vl-column>
            <vl-column key="kl-create-geometry-actions" v-if="showActions">
                <vl-u-spacer mod-medium />
                <vl-action-group>
                    <vl-button type="submit" :mod-disabled="disableSubmit">Geometrie toevoegen</vl-button>
                    <vl-button @click="revert" v-if="modRevertable" mod-icon-before mod-tertiary>Annuleren</vl-button>
                </vl-action-group>
            </vl-column>
        </vl-form-grid>
    </form>
</div>
